import { render, staticRenderFns } from "./ChartPerformanceIndicators.vue?vue&type=template&id=6473556e"
import script from "./ChartPerformanceIndicators.vue?vue&type=script&lang=js"
export * from "./ChartPerformanceIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports